var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseChoice',{attrs:{"title":"関連付ける法人を選択してください","resourceType":"corporation","fields":_vm.fields,"items":_vm.corporation.corporations,"totalItems":_vm.totalCorporations,"isFetching":_vm.isFetching}})}
var staticRenderFns = []

export { render, staticRenderFns }